import Root from './Root.svelte';

const root = new Root({
	target: document.body
});

export default root;